<template>
    <div>
        <div class="shadow_box rounded-lg p-6 relative flex flex-col">
            <p class="title"><strong>Pesquisa</strong></p>
            <form class="mt-1 w-full" @submit.prevent="reloadTable">
                <div class="flex flex-wrap mb-4 px-4">
                    <multi-select-input 
                        v-model="filters.Market.unit"
                        :multiple="true"
                        :options="unitsOptions"
                        class="lg:pr-6 w-full lg:w-1/4"
                        label="Numeração" />
                    
                    <text-input class="lg:pr-6 w-full lg:w-1/4" label="Endereço" v-model="filters.Market.street" />
                    <text-input class="lg:pr-6 w-full lg:w-1/4" label="Bairro" v-model="filters.Market.neighborhood" />

                    <text-input class="lg:pr-6 w-full lg:w-1/4" label="Cidade" v-model="filters.Market.city" />
                    
                    
                    <multi-select-input 
                        v-model="filters.Market.state" 
                        :multiple="true"
                        :options="statesOptionsSearch" 
                        class="lg:pr-6 w-full lg:w-1/4 mt-6" 
                        label="Estado" />

                    <mask-input 
                        class="lg:pr-6 w-full lg:w-1/4 mt-6" 
                        mask="##.###.###/####-##" 
                        label="CNPJ"
                        v-model="filters.Market.cnpj" />
                </div>
                <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md">
                    <button
                        class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
                        @click.submit.prevent="pesquisar">
                        <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
                        Pesquisar
                    </button>
                    <button class="btn flex items-center text-purple-100 font-roboto font-medium uppercase
                        px-6 py-2.5 text-xs leading-tight  ml-1 border-solid border-2 border-purple-100"
                        @click="clearSearch">
                        <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
                        Limpar
                    </button>
                </div>
            </form>
        </div>

        <Head title="Mercados" />
        <div class="shadow_box rounded-lg p-6 mt-4">
            <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">
                <Link :href="'/market_network'">
                <span class="whitespace-nowrap overflow-hidden">Rede:{{ marketnetwork.name }}</span>
                </Link><br>
                Mercados
            </h1>
            <data-table 
                v-if="loadTable" 
                v-model:columns="columns" 
                :route="'list/' + marketnetwork.id"
                no-data-label="Nenhuma mercado cadastrada" 
                :query="getQuery"
                no-result-label="Nenhuma região encontrada">
                    <template #table.cell.content.status="{ value, row }">
                        <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo"
                            @click="changeStatus(row)" />
                    </template>

                    <template #grid.content.body.status="{ value, row }">
                        <switch-input v-model="row.status" labelChecked="Ativo" labelUnchecked="Inativo"
                            @click="changeStatus(row)" />
                    </template>

                    <template #table.cell.content.provider="{ value, row }">
                        <div class="place-self-center grid-cols-2 gap-4">
                            <span class="flex items-center justify-center text-sm">
                                <Link :href="'/market_provider/' + marketnetwork.id + '/' + row.id"
                                    class="rounded p-2 bg-purple-100 text-white">
                                Gerenciar Fornecedores<font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
                                </Link>
                            </span>
                        </div>
                    </template>

                    <template #table.cell.content.actions="{ value, row }">
                        <div class="inline-grid grid-cols-2 gap-4 ">
                            <span 
                                @click="openModalEdit(row)"
                                class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
                                    <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />
                                    Editar
                                </span>
                            
                            <span 
                                @click="openModalConfirmDelete(row)"
                                class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                                    <font-awesome-icon icon="fa-trash-can" class="text-white pr-2" />
                                    Excluir
                            </span>
                        </div>
                    </template>

                    <template #grid.content.body.actions="{ value, row }">
                        <div class="inline-grid grid-cols-2 gap-4 ">
                            <span @click="openModalEdit(row)"
                                class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm"><font-awesome-icon
                                    icon="fa-pencil" class="text-white pr-2" />Editar</span>
                            <span @click="openModalConfirmDelete(row)"
                                class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm"><font-awesome-icon
                                    icon="fa-trash-can" class="text-white text-lg pr-2" />Excluir</span>
                        </div>
                    </template>

                    <template #after.reload-button>
                        <button class="flex items-end font-roboto font-medium btn-purple uppercase"
                            @click.prevent="openModalEdit({})">
                            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span
                                class="hidden lg:block">
                                Adicionar Mercado</span>
                        </button>
                    </template>
            </data-table>
        </div>
        <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
        <modal-edit ref="modalEdit" title="Mercado" url="market" @submitForm="reloadTable"
            :item="{ address: {}, errors: { address: {} } }">
            <template #form="{ item }">
                <text-input v-model="item.unit" :error="item.errors.unit" class="lg:pr-6 w-full lg:w-1/2 mt-6"
                    label="Unidade" required="true" />
                <mask-input v-model="item.cnpj" mask="##.###.###/####-##" :error="item.errors.cnpj"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6" label="CNPJ" required="true" />
                <cep-input @updateAddress="onUpdateAddress" v-model="item.address.postcode"
                    :error="item.errors[`address.postcode`]" class="lg:pr-6 w-full lg:w-2/6 mt-6" label="CEP" />
                <text-input v-model="item.address.street" :error="item.errors[`address.street`]"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Rua" />
                <text-input v-model="item.address.number" :error="item.errors[`address.number`]"
                    class="lg:pr-6 w-full lg:w-1/4 mt-6" label="Numero" />
                <text-input v-model="item.address.complement" :error="item.errors[`address.complement`]"
                    class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Complemento" />
                <text-input v-model="item.address.neighborhood" :error="item.errors[`address.neighborhood`]"
                    class="lg:pr-6 w-full lg:w-1/4 mt-6" label="Bairro" />
                <select-input v-model="item.address.state" :error="item.errors[`address.state`]"
                    class="lg:pr-6 w-full lg:w-1/4 mt-6" label="Estado">
                    <option :value="null" />
                    <option v-for="(value, name, index) in states_options" :key="name" :value="name">{{ value }}</option>
                </select-input>
                <text-input v-model="item.address.city" :error="item.errors[`address.city`]"
                    class="lg:pr-6 w-full lg:w-1/3 mt-6" label="Cidade" />
                <select-input v-model="item.zone_id" :error="item.errors.zone_id" class="lg:pr-6 w-full lg:w-1/3 mt-6"
                    label="Região" required="true">
                    <option :value="null" />
                    <option v-for="(value, name, index) in zone_options" :key="name" :value="name">{{ value }}</option>
                </select-input>
            </template>
        </modal-edit>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import TextInput from '@/Shared/TextInput'
import DataTable from '@/Shared/DataTable'
import CepInput from '@/Shared/CepInput'
import SelectInput from '@/Shared/SelectInput'
import MaskInput from '@/Shared/MaskInput'
import SwitchInput from '@/Shared/SwitchInput'
import MultiSelectInput from '@/Shared/MultiSelectInput'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    TextInput,
    DataTable,
    CepInput,
    SelectInput,
    MaskInput,
    SwitchInput,
    MultiSelectInput,
    Link,
  },
  props: {
    unitsOptions: Array,
    zone_options: Object,
    marketnetwork: Object,
    states_options: Object,
    statesOptionsSearch: Array,
    citiesOptionsSearch: Array,
  },
  layout: Layout,
  data () {
    return {
      loadTable: true,
      columns: [
        {
          uniqid: 'unit',
          label: 'Numeração',
          field: 'unit',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap overflow-hidden text-ellipsis',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'street',
          label: 'Endereco',
          field: 'addresses.street',
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => (row.address ? (row.address.street ? row.address.street + ', ' : '') : '') + (row.address ? (row.address.number ? row.address.number : '') : '')
        },
        {
          uniqid: 'complement',
          label: 'Complemento',
          field: 'addresses.complement',
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.address ? row.address.complement : ''
        },
        {
          uniqid: 'neighborhood',
          label: 'Bairro',
          field: 'addresses.neighborhood',
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.address ? row.address.neighborhood : ''
        },
        {
          uniqid: 'city',
          label: 'Cidade',
          field: 'addresses.city',
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.address ? row.address.city : ''
        },
        {
          uniqid: 'state',
          label: 'UF',
          field: 'addresses.state',
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.address ? row.address.state : ''
        },
        {
          uniqid: 'cnpj',
          label: ' CNPJ',
          field: 'cnpj',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm whitespace-nowrap',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'provider',
          label: 'Fornecedores',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
        {
          uniqid: 'status',
          label: 'Status',
          field: 'status',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        }
      ],
    }
  },

  computed: {
    getQuery() {
      return Object.entries( this.getFilters() ).map( ( [key, val] ) => `search2[${key}]=${val}` ).join( '&' )
    },
  },

  methods: {
    changeStatus (item) {
      item.status = !item.status;
      this.$inertia.post("/market/update-status", item);
    },
    openModalConfirmDelete (item) {
      this.$refs.modalDelete.openModalDelete(item, `/market/${item.id}`, `Deseja realmente excluir essa loja ${item.unit}?`);
    },
    openModalEdit (i) {
      let item = {
        id: i.id,
        unit: i.unit,
        cnpj: i.cnpj,
        zone_id: i.zone_id,
        market_network_id: this.marketnetwork.id,
        address: {},
      }
      if (i.address) {
        item.address = {
          id: i.address.id,
          street: i.address.street,
          number: i.address.number,
          complement: i.address.complement,
          neighborhood: i.address.neighborhood,
          state: i.address.state,
          city: i.address.city,
          postcode: i.address.postcode,
        }
      }

      this.$refs.modalEdit.openModalEdit(item);
    },
    reloadTable () {
      console.log(this.statesOptionsSearch)
            
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    onUpdateAddress (json) {
      this.$refs.modalEdit.item.address.city = json.localidade;
      this.$refs.modalEdit.item.address.state = json.uf;
      this.$refs.modalEdit.item.address.street = json.logradouro;
      this.$refs.modalEdit.item.address.neighborhood = json.bairro;
    },
    clearSearch () {
      this.clearFilters()
      this.reloadTable();
    },
    pesquisar () {
      this.reloadTable();
    },
  },
    
  setup() {
    const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

    setFiltersComponent( 'Market' )

    const clearFilters = () => clearFiltersComponent( 'Market' )
    const getFilters = () => getFiltersComponent( 'Market' )

    return { 
      getFilters,
      clearFilters, 
      filters: filtersStore.filters
    }
  },
}
</script>
